import script from "./faqAir.vue?vue&type=script&setup=true&lang=js"
export * from "./faqAir.vue?vue&type=script&setup=true&lang=js"

import "./faqAir.vue?vue&type=style&index=0&id=af69e664&scoped=true&lang=css"
import "./faqAir.vue?vue&type=style&index=1&id=af69e664&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af69e664"]])

export default __exports__